module.exports = __webpack_public_path__ + "img/heart-icon.b1fda977.svg";